import { Menu, MenuItem } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { startCase } from "lodash";
import styled from "styled-components/macro";

export function AdminRightClickMenu({
  handleClose,
  contextMenu,
  ckey,
  extraMenuItems,
}: {
  contextMenu: { mouseX: number; mouseY: number } | null;
  handleClose: () => void;
  ckey: string;
  extraMenuItems?: React.JSX.Element | React.JSX.Element[];
}) {
  return (
    <StyledMenu
      open={contextMenu !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? {
              top: contextMenu.mouseY,
              left: contextMenu.mouseX,
            }
          : undefined
      }
      disableScrollLock={true}
    >
      <MenuItem onClick={handleClose}>
        <a
          href={`https://${ckey}.gke-us-east1.raven-cloud.com/midgard/admin/deployment_config/flightconfig/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {startCase(ckey)}
          {" — "} Midgard Admin{" "}
          <OpenInNew
            style={{
              transform: "scale(0.75)",
            }}
          />
        </a>
      </MenuItem>
      <MenuItem onClick={handleClose}>
        <a
          href={`https://${ckey}.gke-us-east1.raven-cloud.com/midgard/graphiql/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {startCase(ckey)}
          {" — "} Midgard GraphiQL{" "}
          <OpenInNew
            style={{
              transform: "scale(0.75)",
            }}
          />
        </a>
      </MenuItem>
      {extraMenuItems}
    </StyledMenu>
  );
}
const StyledMenu = styled(Menu)`
  ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  li {
    padding: 6px 16px;
    width: 100%;
    justify-content: normal;
  }
  a {
    display: flex;
    align-items: center;
  }
`;
